import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Grid,
  FormGroup,
  SelectPicker,
  Message,
  RadioGroup,
  Radio,
  InputNumber,
  ButtonToolbar,
  IconButton,
  Icon,
  Modal,
  Button,
  Checkbox,
  InputGroup,
  Whisper,
  Tooltip,
} from 'rsuite'
// import { isRequired, isValidators, isRequiredFiled } from '../../../utils/ValidatorUtils'
import { getMaxLengthData, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ResultView from './ResultView'
import scrollToComponent from 'react-scroll-to-component'
import NumberFormat from 'react-number-format'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import InputForm from '../../../components/forms/input/InputForm'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import { useForm, Controller } from 'react-hook-form'
import { cloneDeep, isEmpty } from 'lodash-es'
import { numberThousandSeparator } from '../../../utils/formatterUtil'

export default function ResultConnectionModal({
  schema: _schema,
  isShowConnection,
  setIsShowConnection,
  indicatorSelectRow,
  //onSelectConnection,
  onSubmitData = () => {},
  isProgress,
  ...props
}) {
  const { isDeleteError, isError, loading, scrollToEdtiForm } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [schema, setSchema] = useState()
  const [currentPage, setCurrentPage] = useState(0)

  const inputTypeKey = {
    checkbox: 'checkbox',
    inputNumber: 'inputNumber',
    inputNumberDropdown: 'inputNumberDropdown',
    inputText: 'inputText', //id = 1100, 1100
    dropdown: 'dropdown',
  }

  useEffect(() => {
    if (_schema) {
      console.log('_schema', _schema)
      setSchema(_schema)
      setCurrentPage(0)
    }
  }, [_schema])

  const onSubmit = (data) => {
    console.log('data', data)
    console.log('schema', schema)

    var outPuts = []
    var outComes = []

    //convert schema to request body pattern
    schema?.pages?.forEach((page, index) => {
      page.output.forEach((row) => {
        let checkbox = row.inputLists.find((e) => e.inputType == inputTypeKey.checkbox)
        let inputNumber = row.inputLists.find((e) => e.inputType == inputTypeKey.inputNumber)
        let inputNumberDropdown = row.inputLists.find(
          (e) => e.inputType == inputTypeKey.inputNumberDropdown
        )
        let inputText = row.inputLists.find((e) => e.inputType == inputTypeKey.inputText)
        let dropdown = row.inputLists.find((e) => e.inputType == inputTypeKey.dropdown)

        //subRow
        if (row.subItems && row.subItems.length > 0) {
          row.subItems.forEach((subRow) => {
            let subCheckbox = subRow.inputLists.find((e) => e.inputType == inputTypeKey.checkbox)
            let subInputNumber = subRow.inputLists.find(
              (e) => e.inputType == inputTypeKey.inputNumber
            )
            let subInputNumberDropdown = subRow.inputLists.find(
              (e) => e.inputType == inputTypeKey.inputNumberDropdown
            )
            let subInputText = subRow.inputLists.find((e) => e.inputType == inputTypeKey.inputText)
            let subDropdown = subRow.inputLists.find((e) => e.inputType == inputTypeKey.dropdown)

            //subSubRow
            if (subRow.subItems && subRow.subItems.length > 0) {
              subRow.subItems.forEach((subSubRow) => {
                let subSubCheckbox = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.checkbox
                )
                let subSubInputNumber = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputNumber
                )
                let subSubInputNumberDropdown = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputNumberDropdown
                )
                let subSubInputText = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputText
                )
                let subSubDropdown = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.dropdown
                )

                let data = {
                  id: subSubRow.id,
                  result: subSubInputNumber?.value || 0,
                  unitType: subSubInputNumberDropdown?.value || '',
                  otherResult: subSubInputText?.value || '',
                  driveLavel: parseInt(subSubDropdown?.value) || 0,
                }
                subSubCheckbox?.value && outPuts.push(data)
              })
            } else {
              let data = {
                id: subRow.id,
                result: subInputNumber?.value || 0,
                unitType: subInputNumberDropdown?.value || '',
                otherResult: subInputText?.value || '',
                driveLavel: parseInt(subDropdown?.value) || 0,
              }
              subCheckbox?.value && outPuts.push(data)
            }
          })
        } else {
          let data = {
            id: row.id,
            result: inputNumber?.value || 0,
            unitType: inputNumberDropdown?.value || '',
            otherResult: inputText?.value || '',
            driveLavel: parseInt(dropdown?.value) || 0,
          }
          checkbox?.value && outPuts.push(data)
        }
      })

      page.outcome.forEach((row) => {
        let checkbox = row.inputLists.find((e) => e.inputType == inputTypeKey.checkbox)
        let inputNumber = row.inputLists.find((e) => e.inputType == inputTypeKey.inputNumber)
        let inputNumberDropdown = row.inputLists.find(
          (e) => e.inputType == inputTypeKey.inputNumberDropdown
        )
        let inputText = row.inputLists.find((e) => e.inputType == inputTypeKey.inputText)
        let dropdown = row.inputLists.find((e) => e.inputType == inputTypeKey.dropdown)

        //subRow
        if (row.subItems && row.subItems.length > 0) {
          row.subItems.forEach((subRow) => {
            let subCheckbox = subRow.inputLists.find((e) => e.inputType == inputTypeKey.checkbox)
            let subInputNumber = subRow.inputLists.find(
              (e) => e.inputType == inputTypeKey.inputNumber
            )
            let subInputNumberDropdown = subRow.inputLists.find(
              (e) => e.inputType == inputTypeKey.inputNumberDropdown
            )
            let subInputText = subRow.inputLists.find((e) => e.inputType == inputTypeKey.inputText)
            let subDropdown = subRow.inputLists.find((e) => e.inputType == inputTypeKey.dropdown)

            //subSubRow
            if (subRow.subItems && subRow.subItems.length > 0) {
              subRow.subItems.forEach((subSubRow) => {
                let subSubCheckbox = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.checkbox
                )
                let subSubInputNumber = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputNumber
                )
                let subSubInputNumberDropdown = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputNumberDropdown
                )
                let subSubInputText = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.inputText
                )
                let subSubDropdown = subSubRow.inputLists.find(
                  (e) => e.inputType == inputTypeKey.dropdown
                )

                let data = {
                  id: subSubRow.id,
                  result: subSubInputNumber?.value || 0,
                  unitType: subSubInputNumberDropdown?.value || '',
                  otherResult: subSubInputText?.value || '',
                  driveLavel: parseInt(subSubDropdown?.value) || 0,
                }
                subSubCheckbox?.value && outComes.push(data)
              })
            } else {
              let data = {
                id: subRow.id,
                result: subInputNumber?.value || 0,
                unitType: subInputNumberDropdown?.value || '',
                otherResult: subInputText?.value || '',
                driveLavel: parseInt(subDropdown?.value) || 0,
              }
              subCheckbox?.value && outComes.push(data)
            }
          })
        } else {
          let data = {
            id: row.id,
            result: inputNumber?.value || 0,
            unitType: inputNumberDropdown?.value || '',
            otherResult: inputText?.value || '',
            driveLavel: parseInt(dropdown?.value) || 0,
          }
          checkbox?.value && outComes.push(data)
        }
      })
    })

    let request = {
      outPuts: outPuts,
      outComes: outComes,
    }

    onSubmitData(request)
  }

  const updateSchemaValue = (schemaClone) => {
    console.log('updateSchemaValue')
    setSchema((state) => ({
      ...state,
      pages: schemaClone.pages,
    }))
  }

  const onValueChange = (value, item, index, row, rowIndex, type) => {
    console.log('value', value)
    var schemaClone = cloneDeep(schema)
    if (type == 'output') {
      schemaClone.pages[currentPage].output[rowIndex].inputLists[index].value = value
    }
    if (type == 'outcome') {
      schemaClone.pages[currentPage].outcome[rowIndex].inputLists[index].value = value
    }
    //setValue(item.inputType + row.id, value)
    updateSchemaValue(schemaClone)
  }

  const onValueChangeSub = (value, item, index, row, rowIndex, subRow, subIndex, type) => {
    var schemaClone = cloneDeep(schema)
    if (type == 'output') {
      schemaClone.pages[currentPage].output[rowIndex].subItems[subIndex].inputLists[index].value =
        value
    }
    if (type == 'outcome') {
      schemaClone.pages[currentPage].outcome[rowIndex].subItems[subIndex].inputLists[index].value =
        value
    }
    //setValue(item.inputType + row.id, value)
    updateSchemaValue(schemaClone)
  }

  const onValueChangeSubSub = (
    value,
    item,
    index,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex,
    type
  ) => {
    var schemaClone = cloneDeep(schema)
    if (type == 'output') {
      schemaClone.pages[currentPage].output[rowIndex].subItems[subIndex].subItems[
        subSubIndex
      ].inputLists[index].value = value
    }
    if (type == 'outcome') {
      schemaClone.pages[currentPage].outcome[rowIndex].subItems[subIndex].subItems[
        subSubIndex
      ].inputLists[index].value = value
    }
    //setValue(item.inputType + row.id, value)
    updateSchemaValue(schemaClone)
  }

  const generateRowItem = (row, rowIndex, type) => {
    let haveInputText = row.inputLists?.find((i) => i.inputType == inputTypeKey.inputText)
    let haveInputNumberDropdown = row.inputLists?.find(
      (i) => i.inputType == inputTypeKey.inputNumberDropdown
    )
    let haveDropdown = row.inputLists?.find((i) => i.inputType == inputTypeKey.dropdown)
    let isHeader = row.inputLists.length == 1

    //dynamic col
    let maxBlock = row.inputLists.length
    let colMd = 0
    let colLg = 0
    let grid = 24
    let lostNumber = 0
    while (grid % maxBlock != 0) {
      grid = grid - 1
      lostNumber = lostNumber + 1
    }
    colMd = grid / maxBlock
    colLg = grid / maxBlock
    let colMdCheckbox = colMd + lostNumber
    let colLgCheckbox = colLg + lostNumber
    if (maxBlock == 2) {
      colMdCheckbox = 16
      colLgCheckbox = 16
      colMd = 8
      colLg = 8
    }

    return (
      <Row key={rowIndex}>
        {row.inputLists?.map((item, index) => {
          switch (item.inputType) {
            case inputTypeKey.checkbox:
              return colCheckbox(
                item,
                index,
                colMdCheckbox,
                colLgCheckbox,
                isHeader,
                type,
                row,
                rowIndex
              )

            case inputTypeKey.inputText:
              return colInputText(item, index, colMd, colLg, type, row, rowIndex)

            case inputTypeKey.inputNumber:
              return colInputNumber(item, index, colMd, colLg, type, row, rowIndex)

            case inputTypeKey.inputNumberDropdown:
              return colInputNumberDropdown(item, index, colMd, colLg, type, row, rowIndex)

            case inputTypeKey.dropdown:
              return colDropdown(item, index, colMd, colLg, type, row, rowIndex)

            default:
              break
          }
        })}
      </Row>
    )
  }

  const generateSubRowItem = (row, rowIndex, subRow, subIndex, type) => {
    let haveInputText = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputText)
    let haveDropdown = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.dropdown)
    let isHeader = subRow.inputLists.length == 1

    //dynamic col
    let maxBlock = subRow.inputLists.length
    let colMd = 0
    let colLg = 0
    let grid = 24
    let lostNumber = 0
    while (grid % maxBlock != 0) {
      grid = grid - 1
      lostNumber = lostNumber + 1
    }
    colMd = grid / maxBlock
    colLg = grid / maxBlock
    let colMdCheckbox = colMd + lostNumber
    let colLgCheckbox = colLg + lostNumber
    if (maxBlock == 2) {
      colMdCheckbox = 16
      colLgCheckbox = 16
      colMd = 8
      colLg = 8
    }

    return (
      <Row key={subIndex} style={{ marginLeft: '1em' }}>
        {subRow.inputLists?.map((item, index) => {
          switch (item.inputType) {
            case inputTypeKey.checkbox:
              return colCheckbox(
                item,
                index,
                colMdCheckbox,
                colLgCheckbox,
                isHeader,
                type,
                row,
                rowIndex,
                subRow,
                subIndex
              )

            case inputTypeKey.inputText:
              return colInputText(item, index, colMd, colLg, type, row, rowIndex, subRow, subIndex)

            case inputTypeKey.inputNumber:
              return colInputNumber(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex
              )

            case inputTypeKey.inputNumberDropdown:
              return colInputNumberDropdown(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex
              )

            case inputTypeKey.dropdown:
              return colDropdown(item, index, colMd, colLg, type, row, rowIndex, subRow, subIndex)

            default:
              break
          }
        })}
      </Row>
    )
  }

  const generateSubSubRowItem = (row, rowIndex, subRow, subIndex, subSubRow, subSubIndex, type) => {
    let haveInputText = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputText)
    let haveDropdown = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.dropdown)
    let isHeader = subSubRow.inputLists.length == 1

    //dynamic col
    let maxBlock = subSubRow.inputLists.length
    let colMd = 0
    let colLg = 0
    let grid = 24
    let lostNumber = 0
    while (grid % maxBlock != 0) {
      grid = grid - 1
      lostNumber = lostNumber + 1
    }
    colMd = grid / maxBlock
    colLg = grid / maxBlock
    let colMdCheckbox = colMd + lostNumber
    let colLgCheckbox = colLg + lostNumber
    if (maxBlock == 2) {
      colMdCheckbox = 16
      colLgCheckbox = 16
      colMd = 8
      colLg = 8
    }

    return (
      <Row key={subSubIndex} style={{ marginLeft: '2em' }}>
        {subSubRow.inputLists?.map((item, index) => {
          switch (item.inputType) {
            case inputTypeKey.checkbox:
              return colCheckbox(
                item,
                index,
                colMdCheckbox,
                colLgCheckbox,
                isHeader,
                type,
                row,
                rowIndex,
                subRow,
                subIndex,
                subSubRow,
                subSubIndex
              )

            case inputTypeKey.inputText:
              return colInputText(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex,
                subSubRow,
                subSubIndex
              )

            case inputTypeKey.inputNumber:
              return colInputNumber(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex,
                subSubRow,
                subSubIndex
              )

            case inputTypeKey.inputNumberDropdown:
              return colInputNumberDropdown(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex,
                subSubRow,
                subSubIndex
              )

            case inputTypeKey.dropdown:
              return colDropdown(
                item,
                index,
                colMd,
                colLg,
                type,
                row,
                rowIndex,
                subRow,
                subIndex,
                subSubRow,
                subSubIndex
              )

            default:
              break
          }
        })}
      </Row>
    )
  }

  const colCheckbox = (
    item,
    index,
    colMd,
    colLg,
    isHeader,
    type,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex
  ) => {
    let _inputNumber
    if (subSubRow && isEmpty(subSubIndex)) {
      _inputNumber = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumber)
    } else if (subRow && isEmpty(subIndex)) {
      _inputNumber = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumber)
    } else if (row && isEmpty(rowIndex)) {
      _inputNumber = row.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumber)
    }
    return (
      <Col
        xs={24}
        sm={24}
        md={isHeader ? 24 : colMd}
        lg={isHeader ? 24 : colLg}
        key={item.inputType + row.id}
      >
        {/* <ErrorMessage error={errors[item.checkbox.name]} /> */}
        <Controller
          key={item.inputType + row.id}
          name={item.inputType + row.id}
          control={control}
          defaultValue={item.value}
          render={(props) => {
            return isHeader ? (
              <b style={{ marginLeft: subSubIndex ? '3em' : subIndex ? '2em' : '1em' }}>
                {item.label}
              </b>
            ) : (
              <Checkbox
                //style={{ marginTop: '12px' }}
                //value={item.checkbox.checked}
                checked={item.value}
                onChange={(e, checked) => {
                  if (subSubRow && isEmpty(subSubIndex)) {
                    onValueChangeSubSub(
                      checked,
                      item,
                      index,
                      row,
                      rowIndex,
                      subRow,
                      subIndex,
                      subSubRow,
                      subSubIndex,
                      type
                    )
                    return
                  }

                  if (subRow && isEmpty(subIndex)) {
                    onValueChangeSub(checked, item, index, row, rowIndex, subRow, subIndex, type)
                    return
                  }

                  if (row && isEmpty(rowIndex)) {
                    onValueChange(checked, item, index, row, rowIndex, type)
                    return
                  }
                }}
              >
                {item.label}{' '}
                {_inputNumber.master && isProgress
                  ? '(' + numberThousandSeparator(_inputNumber.master) + ')'
                  : ''}
              </Checkbox>
            )
          }}
        />
      </Col>
    )
  }

  const colInputText = (
    item,
    index,
    colMd,
    colLg,
    type,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex
  ) => {
    let _checkbox
    if (subSubRow && isEmpty(subSubIndex)) {
      _checkbox = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (subRow && isEmpty(subIndex)) {
      _checkbox = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (row && isEmpty(rowIndex)) {
      _checkbox = row.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    }

    return (
      <Col xs={24} sm={24} md={colMd} lg={colLg} key={item.inputType + row.id}>
        {/* <ErrorMessage error={errors[item.checkbox.name]} /> */}
        <Controller
          key={item.inputType + row.id}
          name={item.inputType + row.id}
          control={control}
          defaultValue={item.value}
          render={(props) => {
            return (
              <Input
                defaultValue={item.value}
                placeholder={item.label}
                onChange={(value) => {
                  if (subSubRow && isEmpty(subSubIndex)) {
                    onValueChangeSubSub(
                      value,
                      item,
                      index,
                      row,
                      rowIndex,
                      subRow,
                      subIndex,
                      subSubRow,
                      subSubIndex,
                      type
                    )
                    return
                  }

                  if (subRow && isEmpty(subIndex)) {
                    onValueChangeSub(value, item, index, row, rowIndex, subRow, subIndex, type)
                    return
                  }

                  if (row && isEmpty(rowIndex)) {
                    onValueChange(value, item, index, row, rowIndex, type)
                    return
                  }
                }}
                disabled={!_checkbox.value}
              />
            )
          }}
        />
      </Col>
    )
  }

  const colInputNumber = (
    item,
    index,
    colMd,
    colLg,
    type,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex
  ) => {
    let _checkbox
    if (subSubRow && isEmpty(subSubIndex)) {
      _checkbox = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (subRow && isEmpty(subIndex)) {
      _checkbox = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (row && isEmpty(rowIndex)) {
      _checkbox = row.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    }

    let _inputNumberDropdown
    if (subSubRow && isEmpty(subSubIndex)) {
      _inputNumberDropdown = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumberDropdown)
    } else if (subRow && isEmpty(subIndex)) {
      _inputNumberDropdown = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumberDropdown)
    } else if (row && isEmpty(rowIndex)) {
      _inputNumberDropdown = row.inputLists?.find((i) => i.inputType == inputTypeKey.inputNumberDropdown)
    }

    return (
      <Col xs={24} sm={24} md={colMd} lg={colLg} key={item.inputType + row.id}>
        <InputGroup>
          <Controller
            key={item.inputType + row.id}
            name={item.inputType + row.id}
            control={control}
            // rules={{
            //   required: isDisabled
            //     ? false
            //     : 'กรุณากรอก ' + item.numberOfPeople.preText + item.numberOfPeople.postText,
            // }}
            value={item.value}
            defaultValue={item.value}
            render={(props) => {
              return (
                <NumberFormat
                  className="rs-input"
                  //style={{minWidth: 100}}
                  thousandSeparator={true}
                  decimalScale={2}
                  //fixedDecimalScale
                  value={item.value}
                  placeholder="จำนวน"
                  onValueChange={(value) => {
                    if (subSubRow && isEmpty(subSubIndex)) {
                      onValueChangeSubSub(
                        value.floatValue,
                        item,
                        index,
                        row,
                        rowIndex,
                        subRow,
                        subIndex,
                        subSubRow,
                        subSubIndex,
                        type
                      )
                      return
                    }

                    if (subRow && isEmpty(subIndex)) {
                      onValueChangeSub(
                        value.floatValue,
                        item,
                        index,
                        row,
                        rowIndex,
                        subRow,
                        subIndex,
                        type
                      )
                      return
                    }

                    if (row && isEmpty(rowIndex)) {
                      onValueChange(value.floatValue, item, index, row, rowIndex, type)
                      return
                    }
                  }}
                  disabled={!_checkbox?.value}
                />
              )
            }}
          />
          {(item.label && !_inputNumberDropdown) && <InputGroup.Addon>{item.label}</InputGroup.Addon>}
        </InputGroup>
      </Col>
    )
  }

  const colInputNumberDropdown = (
    item,
    index,
    colMd,
    colLg,
    type,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex
  ) => {
    let _checkbox
    if (subSubRow && isEmpty(subSubIndex)) {
      _checkbox = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (subRow && isEmpty(subIndex)) {
      _checkbox = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (row && isEmpty(rowIndex)) {
      _checkbox = row.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    }
    return (
      <Col xs={24} sm={24} md={colMd} lg={colLg} key={item.inputType + row.id}>
        <Controller
          key={item.inputType + row.id}
          name={item.inputType + row.id}
          control={control}
          // rules={{
          //   required: isDisabled
          //     ? false
          //     : 'กรุณากรอก ' + item.numberOfPeople.preText + item.numberOfPeople.postText,
          // }}
          value={item.value?.toString()}
          defaultValue={item.value?.toString()}
          render={(props) => {
            return (
              <SelectPicker
                //virtualized={false}
                searchable={false}
                block
                data={item.options}
                placement={'auto'}
                value={item.value?.toString()}
                placeholder={item.label || 'หน่วยนับ'}
                onChange={(value) => {
                  if (subSubRow && isEmpty(subSubIndex)) {
                    onValueChangeSubSub(
                      value,
                      item,
                      index,
                      row,
                      rowIndex,
                      subRow,
                      subIndex,
                      subSubRow,
                      subSubIndex,
                      type
                    )
                    return
                  }

                  if (subRow && isEmpty(subIndex)) {
                    onValueChangeSub(value, item, index, row, rowIndex, subRow, subIndex, type)
                    return
                  }

                  if (row && isEmpty(rowIndex)) {
                    onValueChange(value, item, index, row, rowIndex, type)
                    return
                  }
                }}
                disabled={!_checkbox?.value}
              />
            )
          }}
        />
      </Col>
    )
  }

  const colDropdown = (
    item,
    index,
    colMd,
    colLg,
    type,
    row,
    rowIndex,
    subRow,
    subIndex,
    subSubRow,
    subSubIndex
  ) => {
    let _checkbox
    if (subSubRow && isEmpty(subSubIndex)) {
      _checkbox = subSubRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (subRow && isEmpty(subIndex)) {
      _checkbox = subRow.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    } else if (row && isEmpty(rowIndex)) {
      _checkbox = row.inputLists?.find((i) => i.inputType == inputTypeKey.checkbox)
    }
    return (
      <Col xs={24} sm={24} md={colMd} lg={colLg} key={item.inputType + row.id}>
        <Controller
          key={item.inputType + row.id}
          name={item.inputType + row.id}
          control={control}
          // rules={{
          //   required: isDisabled
          //     ? false
          //     : 'กรุณากรอก ' + item.numberOfPeople.preText + item.numberOfPeople.postText,
          // }}
          value={item.value?.toString()}
          defaultValue={item.value?.toString()}
          render={(props) => {
            return (
              <SelectPicker
                //virtualized={false}
                searchable={false}
                block
                data={item.options}
                placement={'auto'}
                value={item.value?.toString()}
                placeholder={item.label || 'เลือก'}
                onChange={(value) => {
                  if (subSubRow && isEmpty(subSubIndex)) {
                    onValueChangeSubSub(
                      value,
                      item,
                      index,
                      row,
                      rowIndex,
                      subRow,
                      subIndex,
                      subSubRow,
                      subSubIndex,
                      type
                    )
                    return
                  }

                  if (subRow && isEmpty(subIndex)) {
                    onValueChangeSub(value, item, index, row, rowIndex, subRow, subIndex, type)
                    return
                  }

                  if (row && isEmpty(rowIndex)) {
                    onValueChange(value, item, index, row, rowIndex, type)
                    return
                  }
                }}
                disabled={!_checkbox?.value}
              />
            )
          }}
        />
      </Col>
    )
  }

  return (
    <>
      {schema && (
        <div className="modal-container">
          <Modal
            backdrop="static"
            size=""
            show={isShowConnection}
            onHide={(e) => {
              setIsShowConnection(false)
              setSchema()
            }}
            style={{ marginRight: 10, marginLeft: 10 }}
          >
            <Modal.Header>
              <Modal.Title style={{ paddingTop: 5 }}>{schema?.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: 10 }}>
              <p>
                <b>{schema?.pages[currentPage].label}</b>
              </p>
              <Row style={{ marginTop: 0 }}>
                <Col xs={24} sm={24} md={12} lg={12} style={{ textAlign: 'center' }}>
                  <div style={{ padding: 10 }}>
                    <Row style={{ borderStyle: 'solid', borderWidth: 1.5, borderColor: '#e5e5ea' }}>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ fontWeight: 'bold' }}>
                        <div style={{ padding: 8 }}>ระดับ output</div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        marginTop: 20,
                        textAlign: 'left',
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                    >
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div>
                          {schema?.pages[currentPage].output &&
                            schema?.pages[currentPage].output.length > 0 &&
                            schema?.pages[currentPage].output?.map((row, rowIndex) => {
                              return (
                                <>
                                  {generateRowItem(row, rowIndex, 'output')}
                                  {row.subItems &&
                                    row.subItems.length > 0 &&
                                    row.subItems?.map((subRow, subIndex) => {
                                      return (
                                        <>
                                          {generateSubRowItem(
                                            row,
                                            rowIndex,
                                            subRow,
                                            subIndex,
                                            'output'
                                          )}
                                          {subRow.subItems &&
                                            subRow.subItems.length > 0 &&
                                            subRow.subItems?.map((subSubRow, subSubIndex) => {
                                              return generateSubSubRowItem(
                                                row,
                                                rowIndex,
                                                subRow,
                                                subIndex,
                                                subSubRow,
                                                subSubIndex,
                                                'output'
                                              )
                                            })}
                                        </>
                                      )
                                    })}
                                </>
                              )
                            })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} style={{ textAlign: 'center' }}>
                  <div style={{ padding: 10 }}>
                    <Row style={{ borderStyle: 'solid', borderWidth: 1.5, borderColor: '#e5e5ea' }}>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ fontWeight: 'bold' }}>
                        <div style={{ padding: 8 }}>ระดับ outcome</div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        marginTop: 20,
                        textAlign: 'left',
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                    >
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div>
                          {schema?.pages[currentPage].outcome &&
                            schema?.pages[currentPage].outcome.length > 0 &&
                            schema?.pages[currentPage].outcome?.map((row, rowIndex) => {
                              return (
                                <>
                                  {generateRowItem(row, rowIndex, 'outcome')}
                                  {row.subItems &&
                                    row.subItems.length > 0 &&
                                    row.subItems?.map((subRow, subIndex) => {
                                      return (
                                        <>
                                          {generateSubRowItem(
                                            row,
                                            rowIndex,
                                            subRow,
                                            subIndex,
                                            'outcome'
                                          )}
                                          {subRow.subItems &&
                                            subRow.subItems.length > 0 &&
                                            subRow.subItems?.map((subSubRow, subSubIndex) => {
                                              return generateSubSubRowItem(
                                                row,
                                                rowIndex,
                                                subRow,
                                                subIndex,
                                                subSubRow,
                                                subSubIndex,
                                                'outcome'
                                              )
                                            })}
                                        </>
                                      )
                                    })}
                                </>
                              )
                            })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer style={{ textAlign: 'center' }}>
              <p>
                {currentPage + 1} / {schema?.pages.length}
              </p>
              <Button
                onClick={(e) => {
                  setCurrentPage(currentPage - 1)
                }}
                appearance="ghost"
                disabled={currentPage == 0}
              >
                <Icon icon={'angle-double-left'} /> ย้อนกลับ
              </Button>
              <Button onClick={handleSubmit(onSubmit)} appearance="primary">
                บันทึก
              </Button>
              <Button
                onClick={(e) => {
                  setCurrentPage(currentPage + 1)
                }}
                appearance="ghost"
                disabled={currentPage == schema?.pages.length - 1}
              >
                ต่อไป <Icon icon={'angle-double-right'} />
              </Button>
              {/* <Button
            onClick={(e) => {
              setIsShowConnection(false)
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button> */}
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  )
}
